<div class="flex h-screen bg-gray-100 font-sans text-sm">
  <!-- Left Sidebar (Inbox) -->
  <aside class="w-64 bg-white border-r flex flex-col">
    <div class="p-4 border-b flex items-center justify-between">
      <span class="font-bold text-purple-700">Inbox</span>
      <span class="text-xs font-semibold text-purple-700 bg-purple-100 rounded-full px-2 py-0.5">
        {{ unansweredMessages().length }}
      </span>
    </div>
    <div class="flex-1 overflow-y-auto divide-y">
      @for (message of unansweredMessages(); track message.number_id + '_' + message.provider_code_id) {
        <button
          type="button"
          class="w-full text-left p-3 flex flex-col gap-1 hover:bg-purple-50 transition-colors"
          [ngClass]="
            message.number_id === currentUser && message.provider_code_id === currentProviderCodeId
              ? 'bg-purple-100 border-l-4 border-purple-600'
              : ''
          "
          (click)="onUnansweredMessageClick(message.number_id, message.provider_code_id, message.code, message.prefix_code)"
        >
          <div class="flex items-center justify-between gap-2">
            <div class="flex items-center gap-1">
              <span class="text-xs font-mono font-bold text-purple-700 bg-purple-100 rounded px-1.5 py-0.5">
                {{ message.prefix_code }}
              </span>
              <span class="text-xs font-mono font-bold text-gray-600 bg-gray-100 rounded px-1.5 py-0.5">
                {{ message.code }}
              </span>
            </div>
            <span class="text-[10px] text-gray-400 whitespace-nowrap">{{ message.created_at | date: 'HH:mm' }}</span>
          </div>
          <div class="text-xs text-gray-500">{{ message.phone_number }}</div>
          <div class="text-sm text-gray-800 truncate">{{ message.message }}</div>
        </button>
      } @empty {
        <p class="p-4 text-center text-xs text-gray-400">Nema nepročitanih poruka.</p>
      }
    </div>
    <div class="p-4 border-t space-y-2">
      <app-left-sidebar></app-left-sidebar>
    </div>
  </aside>

  <!-- Main Content (Chat) -->
  <main class="flex-1 flex flex-col bg-purple-50">
    <header class="p-4 border-b bg-white flex items-center gap-2">
      @if (currentProviderCodeId !== null) {
        <span class="text-xs font-mono font-bold text-purple-700 bg-purple-100 rounded px-2 py-0.5">
          {{ providerPrefix() }}{{ providerCode() }}
        </span>
        <span class="font-bold text-gray-800">{{ number() }}</span>
      } @else {
        <span class="font-bold text-gray-400">Izaberi broj sa leve strane</span>
      }
    </header>
    <div class="flex-1 p-6 overflow-y-auto space-y-3">
      @for (message of messages(); track message.id) {
        <div class="flex" [ngClass]="message.mine ? 'justify-end' : 'justify-start'">
          <div
            class="max-w-md rounded-2xl px-4 py-2 shadow-sm"
            [ngClass]="message.mine ? 'bg-purple-600 text-white rounded-br-sm' : 'bg-white text-gray-800 border rounded-bl-sm'"
          >
            <p class="whitespace-pre-wrap break-words">{{ message.message }}</p>
            <p class="text-[10px] mt-1 text-right" [ngClass]="message.mine ? 'text-purple-200' : 'text-gray-400'">
              {{ message.created_at | date: 'dd.MM.yyyy HH:mm' }}
            </p>
          </div>
        </div>
      } @empty {
        <p class="text-center text-gray-400 mt-10">Nema poruka za prikaz</p>
      }
    </div>
    @if (currentProviderCodeId !== null) {
      <div class="p-4 bg-white border-t space-y-2">
        <textarea
          #messageInput
          class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none resize-none"
          rows="3"
          placeholder="Kucaj ili diktiraj..."
          [(ngModel)]="messageText"
          (keydown.enter)="onMessageInputEnter($event)"
        ></textarea>
        <div class="flex justify-between items-center">
          <button class="px-4 py-2 border rounded-lg text-gray-600 hover:bg-gray-100 flex items-center gap-1 transition-colors">
            <span>🎤</span> GLAS
          </button>
          <button
            (click)="sendMessage(false)"
            [disabled]="!messageText().trim()"
            class="px-8 py-2 border border-purple-600 text-purple-600 rounded-lg font-bold hover:bg-purple-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            POŠALJI KAO KLIJENT(test)
          </button>
          <button
            (click)="sendMessage()"
            [disabled]="!messageText().trim()"
            class="px-8 py-2 bg-purple-600 text-white rounded-lg font-bold hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            POŠALJI
          </button>
        </div>
      </div>
    }
  </main>

  @if (currentProviderCodeId !== null) {
    <section class="w-80 bg-white border-l flex flex-col">
      <div class="p-4 border-b">
        <span class="font-bold text-purple-700">Dosije</span>
      </div>

      <div class="flex-1 overflow-y-auto p-4 space-y-4">
        <div>
          <label class="block text-xs font-bold uppercase text-gray-500 mb-1">Identitet</label>
          <input
            type="text"
            class="w-full border rounded-lg p-2 focus:ring-2 focus:ring-purple-500 outline-none"
            placeholder="Upiši ime..."
            [(ngModel)]="identity"
          />
        </div>
        <div>
          <label class="block text-xs font-bold uppercase text-gray-500 mb-1">Profil</label>
          <textarea
            class="w-full border rounded-lg p-2 bg-gray-50 text-xs focus:ring-2 focus:ring-purple-500 outline-none"
            rows="3"
            placeholder="Profil..."
            [(ngModel)]="profile"
          ></textarea>
        </div>
        <div>
          <label class="block text-xs font-bold uppercase text-gray-500 mb-1">Beleške</label>
          <textarea
            class="w-full border rounded-lg p-2 bg-gray-50 text-xs focus:ring-2 focus:ring-purple-500 outline-none"
            rows="3"
            placeholder="Beleške..."
            [(ngModel)]="note"
          ></textarea>
        </div>
        <div>
          <label class="block text-xs font-bold uppercase text-gray-500 mb-1">Kanali</label>
          <div class="flex flex-wrap gap-1.5">
            @for (channel of channels(); track channel.id) {
              @if (channel.id === currentProviderCodeId) {
                <span
                  class="text-xs font-semibold text-gray-500 bg-gray-100 rounded-full px-2 py-0.5 cursor-default"
                >
                  {{ channel.prefix_code }}{{ channel.code }}
                </span>
              } @else {
                <button
                  type="button"
                  (click)="openChannelChat(channel)"
                  class="text-xs font-semibold text-purple-700 bg-purple-100 rounded-full px-2 py-0.5 hover:bg-purple-200 transition-colors"
                >
                  {{ channel.prefix_code }}{{ channel.code }}
                </button>
              }
            } @empty {
              <span class="text-xs text-gray-400">Nema kanala.</span>
            }
          </div>
        </div>
      </div>

      <div class="p-4 border-t">
        <button
          (click)="saveFile()"
          class="w-full py-3 bg-purple-700 text-white font-bold rounded-lg hover:bg-purple-800 transition-colors"
        >
          SAČUVAJ SVE
        </button>
      </div>
    </section>
  }

  @if (selectedChannel(); as channel) {
    <app-chat-modal
      [numberId]="currentUser!"
      [providerCodeId]="channel.id"
      [phoneNumber]="number()"
      [historyOnly]="true"
      (closeModal)="closeChannelChat()"
    ></app-chat-modal>
  }
</div>
